import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { Loader2 } from 'lucide-react';

import { ToolEditor } from '@/components/settings/tools/tool-editor';

export const Route = createFileRoute('/_app/settings/tools/$id/')({
  component: ToolDetailRoute,
});

function LoadingFallback() {
  return (
    <div className="flex h-64 items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
    </div>
  );
}

function ToolDetailRoute() {
  const { id } = Route.useParams();
  return (
    <Suspense fallback={<LoadingFallback />}>
      <ToolEditor serverId={id} />
    </Suspense>
  );
}
